<app-page-header [backLink]="['/home/customer-spaces']" [usePreviousPathIfAvailable]="true"></app-page-header>
<div class="title-container">
  <h1 *ngIf="!customerSpaceId">{{ 'customer-spaces.create-customer.title' | translate }}</h1>
  <h1 *ngIf="customerSpaceId">{{ 'customer-spaces.update-customer.title' | translate }}</h1>
  <div *ngIf="customerSpaceId && !isCustomerSpaceActive">
    <a class="primary-link" (click)="tryDeleteCustomerSpace()" *appShowAuthorize="'CUSTOMER_SPACE_DELETE'">
      <mat-icon svgIcon="delete" class="delete-icon"></mat-icon>
      <span>{{ 'customer-spaces.delete-customer.title' | translate }}</span>
    </a>
  </div>
</div>

<h2>{{ 'customer-spaces.create-customer-form.company' | translate }}</h2>

<app-create-user-form *ngIf="1" [customerSpaceId]="customerSpaceId" [cf]="customerForm" [deactivatedBy]="deactivatedBy"
  [deactivationTime]="deactivationTime" [isPortalAdministrator]="isPortalAdministrator" />
<app-pre [obj]="customerForm.value" />

<form *ngIf="0" class="create-customer-form" [formGroup]="customerForm" (keydown.enter)="saveCustomer($event)">
  <div class="company-form-fields-container">
    <mat-form-field color="accent" class="form-field">
      <mat-label>{{ 'customer-spaces.create-customer-form.company' | translate }}</mat-label>
      <input matInput formControlName="name" required autocomplete="not" autofocus [name]="randomName1" />
      <mat-error *ngIf="customerForm.get('name')!.hasError('required')">
        {{ 'customer-spaces.create-customer-form.error.company-required' | translate }}
      </mat-error>
      <mat-error *ngIf="customerForm.get('name')!.hasError('maxlength')">
        {{ 'shared.error.max-length' | translate }}
      </mat-error>
      <mat-error *ngIf="customerForm.get('name')!.hasError('backendError')">
        {{ customerForm.get('name')!.getError('backendError') }}
      </mat-error>
    </mat-form-field>

    <mat-form-field color="accent" class="form-field">
      <mat-label>{{ 'customer-spaces.create-customer-form.erp-address-number' | translate }}</mat-label>
      <input matInput formControlName="erpAddressNumber" required autocomplete="not" />
      <mat-error *ngIf="customerForm.get('erpAddressNumber')!.hasError('required')">
        {{ 'customer-spaces.create-customer-form.error.erp-address-number-required' | translate }}
      </mat-error>
      <mat-error *ngIf="customerForm.get('erpAddressNumber')!.hasError('maxlength')">
        {{ 'shared.error.max-length' | translate }}
      </mat-error>
      <mat-error *ngIf="customerForm.get('erpAddressNumber')!.hasError('backendError')">
        {{ customerForm.get('name')!.getError('backendError') }}
      </mat-error>
    </mat-form-field>

    <mat-form-field color="accent" class="form-field">
      <mat-label>{{ 'customer-spaces.create-customer-form.erp-project-number' | translate }} 1</mat-label>
      <input matInput formControlName="erpProjectNumber1" required autocomplete="not" />
      <mat-error *ngIf="customerForm.get('erpProjectNumber1')!.hasError('required')">
        {{ 'customer-spaces.create-customer-form.error.erp-project-number-required' | translate }}
      </mat-error>
      <mat-error *ngIf="customerForm.get('erpProjectNumber1')!.hasError('maxlength')">
        {{ 'shared.error.max-length' | translate }}
      </mat-error>
      <mat-error *ngIf="customerForm.get('erpProjectNumber1')!.hasError('pattern')">
        {{ 'customer-spaces.create-customer-form.error.erp-project-number-pattern' | translate }}
      </mat-error>
      <mat-error *ngIf="customerForm.get('erpProjectNumber1')!.hasError('backendError')">
        {{ customerForm.get('name')!.getError('backendError') }}
      </mat-error>
    </mat-form-field>

    <mat-form-field color="accent" class="form-field">
      <mat-label>{{ 'customer-spaces.create-customer-form.erp-project-number' | translate }} 2</mat-label>
      <input matInput formControlName="erpProjectNumber2" autocomplete="not" />
      <mat-error *ngIf="customerForm.get('erpProjectNumber2')!.hasError('maxlength')">
        {{ 'shared.error.max-length' | translate }}
      </mat-error>
      <mat-error *ngIf="customerForm.get('erpProjectNumber2')!.hasError('pattern')">
        {{ 'customer-spaces.create-customer-form.error.erp-project-number-pattern' | translate }}
      </mat-error>
      <mat-error *ngIf="customerForm.get('erpProjectNumber2')!.hasError('backendError')">
        {{ customerForm.get('name')!.getError('backendError') }}
      </mat-error>
    </mat-form-field>

    <mat-form-field color="accent" class="form-field">
      <mat-label>{{ 'customer-spaces.create-customer-form.abacus-instance' | translate }}</mat-label>
      <mat-select formControlName="abacusInstanceId">
        <mat-option></mat-option>
        <mat-option *ngFor="let abacusInstance of abacusInstances$ | async" [value]="abacusInstance">
          {{ abacusInstance }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="customerForm.hasError('abacusInvalid')">
        {{ 'customer-spaces.create-customer-form.error.abacus-instance-required' | translate }}
      </mat-error>
    </mat-form-field>

    <!-- <app-form-select controlKey="abacusInstanceId" [items]="(abacusInstances$ | async)!" [includeEmptyOption]="true" />
    <app-pre *ngIf="1" [obj]="abacusInstances$ | async" /> -->

    <mat-form-field color="accent" class="form-field">
      <mat-label>{{ 'customer-spaces.create-customer-form.abacus-mandator' | translate }}</mat-label>
      <input matInput formControlName="abacusMandatorId" autocomplete="not" />
      <mat-error *ngIf="customerForm.hasError('abacusInvalid')">
        {{ 'customer-spaces.create-customer-form.error.abacus-mandator-required' | translate }}
      </mat-error>
      <mat-error *ngIf="customerForm.get('abacusMandatorId')!.hasError('maxlength')">
        {{ 'shared.error.max-length' | translate }}
      </mat-error>
      <mat-error *ngIf="customerForm.get('abacusMandatorId')!.hasError('backendError')">
        {{ customerForm.get('abacusMandatorId')!.getError('backendError') }}
      </mat-error>
    </mat-form-field>

    <mat-form-field color="accent" class="form-field"
      *ngIf="customerForm.get('erpProjectNumber2')!.value !== '' || customerForm.get('erpProjectNumber3')!.value !== ''">
      <mat-label>{{ 'customer-spaces.create-customer-form.erp-project-number' | translate }} 3</mat-label>
      <input matInput formControlName="erpProjectNumber3" autocomplete="not" />
      <mat-error *ngIf="customerForm.get('erpProjectNumber3')!.hasError('maxlength')">
        {{ 'shared.error.max-length' | translate }}
      </mat-error>
      <mat-error *ngIf="customerForm.get('erpProjectNumber3')!.hasError('pattern')">
        {{ 'customer-spaces.create-customer-form.error.erp-project-number-pattern' | translate }}
      </mat-error>
      <mat-error *ngIf="customerForm.get('erpProjectNumber3')!.hasError('backendError')">
        {{ customerForm.get('name')!.getError('backendError') }}
      </mat-error>
    </mat-form-field>

    <mat-form-field color="accent" class="form-field"
      *ngIf="customerForm.get('erpProjectNumber3')!.value !== '' || customerForm.get('erpProjectNumber4')!.value !== ''">
      <mat-label>{{ 'customer-spaces.create-customer-form.erp-project-number' | translate }} 4</mat-label>
      <input matInput formControlName="erpProjectNumber4" autocomplete="not" />
      <mat-error *ngIf="customerForm.get('erpProjectNumber4')!.hasError('maxlength')">
        {{ 'shared.error.max-length' | translate }}
      </mat-error>
      <mat-error *ngIf="customerForm.get('erpProjectNumber4')!.hasError('pattern')">
        {{ 'customer-spaces.create-customer-form.error.erp-project-number-pattern' | translate }}
      </mat-error>
      <mat-error *ngIf="customerForm.get('erpProjectNumber4')!.hasError('backendError')">
        {{ customerForm.get('name')!.getError('backendError') }}
      </mat-error>
    </mat-form-field>
  </div>
  <div class="form-row">
    <div *ngIf="!!customerSpaceId" class="button-toggle-container">
      <span class="mat-caption">{{ 'customer-spaces.create-customer-form.status' | translate }}</span>
      <mat-button-toggle-group formControlName="status" class="status-toggle">
        <mat-button-toggle [value]="'Active'">
          {{ 'customer-spaces.status.active' | translate }}
        </mat-button-toggle>
        <mat-button-toggle [value]="'Inactive'">
          {{ 'customer-spaces.status.inactive' | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="deactivation-comment">
      <mat-form-field class="comment-input" color="accent" *ngIf="isInactiveSelected()">
        <mat-label>{{ 'customer-spaces.create-customer-form.deactivation-comment' | translate }}</mat-label>
        <textarea matInput formControlName="deactivationComment" rows="3"></textarea>
        <mat-error *ngIf="customerForm.get('deactivationComment')!.hasError('deactivationCommentRequired')">
          {{ 'customer-spaces.create-customer-form.error.deactivation-comment-mandatory' | translate }}
        </mat-error>
      </mat-form-field>
      <div class="deactivated-by" *ngIf="isInactiveSelected()">{{ deactivatedBy }} {{ deactivationTime | date:
        'dd.MM.yyyy HH:mm' }}</div>
    </div>
  </div>
</form>

<div class="button-group">
  <button mat-flat-button [routerLink]="[]" (click)="navigateBack()" [disabled]="savePending$ | async" mat-button>
    {{ 'shared.cancel' | translate | uppercase }}
  </button>
  <button mat-flat-button color="primary" (click)="saveCustomer($event)"
    [disabled]="!customerForm.valid || (savePending$ | async)" mat-button>
    {{ 'shared.save' | translate | uppercase }}
  </button>
</div>

<app-customer-space-users-table [users]="customerSpaceUsers" [isCustomerSpaceActive]="isCustomerSpaceActive"
  [customerSpaceId]="customerSpaceId" [titleTranslateKey]="'customer-spaces.user-management.employees'"
  (addEmployeeClicked)="openAddEmployeeDialog()" (editEmployeeClicked)="openEditEmployeeDialog($event)"
  (deleteEmployeeClicked)="deleteEmployee($event)">

</app-customer-space-users-table>

<app-loading-spinner-overlay *ngIf="savePending$ | async"
  [loadingHintTranslationKey]="(!customerSpaceId ? 'loading-hint.creation' : null)!"></app-loading-spinner-overlay>